import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadMoreButtonComponent } from './load-more-button/load-more-button.component';
import { ResultsLabelComponent } from './results-label/results-label.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [LoadMoreButtonComponent, ResultsLabelComponent],
  imports: [CommonModule, TranslateModule],
  exports: [LoadMoreButtonComponent, ResultsLabelComponent],
})
export class PaginationModule {}
